// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nyxwR","content":"Layout_content__fwmv4","main":"Layout_main__FxQfo","layoutScrollable":"Layout_layoutScrollable__kAYDG"};